/**
 * @file
 * Patria contact section dropdowns.
 */

(function ($, Drupal) {

  'use strict';


  // if ($('body').hasClass('page-node-type-contact-section-subpage')
  //   || $('body').hasClass('page-node-type-contact-section-homepage')) {
  //   if (typeof Drupal.geolocation == 'undefined') {
  //     waintUntilMapIsAvailable();
  //   }
  // }
  //
  // // Function for fading in map when it has loaded.q
  // function waintUntilMapIsAvailable() {
  //
  //   if (typeof Drupal.geolocation == 'undefined') {
  //     setTimeout(waintUntilMapIsAvailable, 300);
  //   } else {
  //     if (typeof Drupal.geolocation.maps[0] == 'undefined') {
  //       setTimeout(waintUntilMapIsAvailable, 300);
  //     } else {
  //       var executed = Drupal.geolocation.maps[0].features.map_type_style.executed;
  //       if (executed === false) {
  //         setTimeout(waintUntilMapIsAvailable, 300);
  //       } else {
  //         $('.block-views-blockcontact-sectiong-map-contact-map-all')
  //           .css('visibility', 'visible')
  //           .animate({ opacity: 1.0 });
  //
  //         $('.block-views-blockcontact-sectiong-map-contact-map-referenced')
  //           .css('visibility', 'visible')
  //           .animate({ opacity: 1.0 });
  //       }
  //     }
  //   }
  // }


  Drupal.behaviors.contact_select = {
    attach: function (context, settings) {

      if ($('#contact-select-wrapper').length) {

        // Init select2
        $('.contact-select.unit select').select2({
          minimumResultsForSearch: -1
        });

        $('.contact-select.service select').select2({
          minimumResultsForSearch: -1
        });

        $('.contact-select.product select').select2({
          minimumResultsForSearch: -1
        });

        // Listen for changes on select
        $('.contact-select select').on('change', function() {
          redirectUser($(this).val());
        });

      }

      // Function for redirecting user on select change
      function redirectUser(url) {
        if (url !== "") {
          window.location.href = url;
        }
      }

    }
  };

})(jQuery, Drupal);
